import { useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import SeoHead from "@/components/feature/SeoHead";
import { articles } from "@/mocks/articles";
import { categories } from "@/mocks/categories";
import { hotTopics } from "@/mocks/hotTopics";
import { homeFAQ } from "@/mocks/faq";

function formatNumber(n: number): string {
  if (n >= 10000) return `${(n / 10000).toFixed(1)}万`;
  return n.toString();
}

export default function Home() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  const featuredArticles = articles.slice(0, 6);
  const latestArticles = articles.slice(0, 8);

  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "黑料在线",
    url: "http://lvepkfa.cn/",
    description:
      "黑料在线聚合海量黑料视频在线观看资源，每日黑料吃瓜网精选全网热门爆料与网红反差大瓜",
    potentialAction: {
      "@type": "SearchAction",
      target: "http://lvepkfa.cn/search?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  };

  const orgSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "黑料在线",
    url: "http://lvepkfa.cn/",
    logo: "http://lvepkfa.cn/logo.png",
    description: "专业的娱乐爆料聚合平台，每日精选全网热门八卦",
    sameAs: ["http://lvepkfa.cn/"],
  };

  const webpageSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "黑料在线 - 黑料视频在线观看与每日黑料吃瓜网",
    url: "http://lvepkfa.cn/",
    description:
      "黑料在线聚合海量黑料视频在线观看资源，每日黑料吃瓜网精选全网热门爆料与网红反差大瓜。国产在线黑料实时追踪，黑料在线不打烊持续更新。",
    isPartOf: {
      "@type": "WebSite",
      name: "黑料在线",
      url: "http://lvepkfa.cn/",
    },
    primaryImageOfPage: {
      "@type": "ImageObject",
      url: "https://readdy.ai/api/search-image?query=Dramatic%20entertainment%20news%20stage%20with%20spotlights%20and%20red%20accents%2C%20dark%20elegant%20atmosphere%2C%20cinematic%20hero%20banner%2C%20gossip%20show%20aesthetic%2C%20warm%20amber%20and%20crimson%20tones&width=1200&height=630&seq=hero-main&orientation=landscape",
    },
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "首页",
        item: "http://lvepkfa.cn/",
      },
    ],
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: homeFAQ.map((faq) => ({
      "@type": "Question",
      name: faq.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: faq.answer,
      },
    })),
  };

  return (
    <div className="min-h-screen bg-background-50">
      <SeoHead
        title="黑料在线 - 黑料视频在线观看与每日黑料吃瓜网 | 国产在线黑料实时更新"
        description="黑料在线聚合海量黑料视频在线观看资源，每日黑料吃瓜网精选全网热门爆料与网红反差大瓜。国产在线黑料实时追踪，黑料在线不打烊持续更新，吃瓜群众必备的在线看料入口。"
        keywords="黑料在线,黑料视频在线观看,每日黑料吃瓜网,国产在线黑料,黑料在线观看,黑料在线不打烊,黑料社区在线观看,今日黑料在线观看,在线看黑料,黑料最新在线"
        canonicalUrl="http://lvepkfa.cn/"
        ogType="website"
        schema={[websiteSchema, orgSchema, webpageSchema, breadcrumbSchema, faqSchema]}
      />

      <Navbar />

      <main>
        {/* Hero Section */}
        <section className="relative h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Dramatic%20entertainment%20news%20stage%20with%20spotlights%20and%20red%20accents%2C%20dark%20elegant%20atmosphere%2C%20cinematic%20hero%20banner%2C%20gossip%20show%20aesthetic%2C%20warm%20amber%20and%20crimson%20tones%20with%20deep%20shadows%20and%20smoke%20effects&width=1600&height=900&seq=hero-main&orientation=landscape"
              alt="黑料在线 - 娱乐爆料聚合平台"
              className="w-full h-full object-cover object-top"
              width={1600}
              height={900}
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60" />
          </div>
          <div className="relative z-10 text-center px-4 max-w-4xl mx-auto">
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 md:mb-6 leading-tight tracking-tight">
              黑料在线
              <br />
              <span className="text-accent-400">每日吃瓜不打烊</span>
            </h1>
            <p className="text-base md:text-lg text-white/80 mb-6 md:mb-8 max-w-2xl mx-auto leading-relaxed">
              聚合全网热门爆料与网红反差大瓜，国产在线黑料实时追踪
              <br className="hidden md:block" />
              吃瓜群众必备的在线看料入口
            </p>
            <Link
              to="/category/entertainment"
              className="inline-flex items-center gap-2 px-6 md:px-8 py-3 md:py-3.5 bg-primary-500 text-background-50 rounded-full text-sm md:text-base font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              立即吃瓜
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </section>

        {/* Categories Grid */}
        <section className="px-4 md:px-6 lg:px-8 py-10 md:py-16 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-end justify-between mb-6 md:mb-8">
              <div>
                <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
                  热门分类
                </h2>
                <p className="text-sm md:text-base text-foreground-500">
                  六大频道覆盖全网八卦爆料，精准锁定你的吃瓜需求
                </p>
              </div>
              <Link
                to="/category/entertainment"
                className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors"
              >
                查看全部
                <i className="ri-arrow-right-line" />
              </Link>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="group relative rounded-xl overflow-hidden aspect-[4/3] cursor-pointer"
                  title={cat.name}
                >
                  <img
                    src={cat.image}
                    alt={cat.name}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                    width={400}
                    height={300}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />
                  <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
                    <div className="flex items-center gap-1.5 mb-1">
                      <span className="w-5 h-5 flex items-center justify-center text-accent-400">
                        <i className={`${cat.icon} text-xs`} />
                      </span>
                      <span className="text-white font-semibold text-sm md:text-base">
                        {cat.name}
                      </span>
                    </div>
                    <p className="text-white/60 text-xs">
                      {cat.articleCount}篇爆料
                    </p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Stats Section */}
        <section className="px-4 md:px-6 lg:px-8 py-10 md:py-16 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
              <div className="text-center">
                <div className="text-3xl md:text-4xl font-bold text-primary-500 mb-1">
                  10,000<span className="text-accent-500">+</span>
                </div>
                <p className="text-sm text-foreground-500">篇精选爆料</p>
              </div>
              <div className="text-center">
                <div className="text-3xl md:text-4xl font-bold text-primary-500 mb-1">
                  500<span className="text-accent-500">万+</span>
                </div>
                <p className="text-sm text-foreground-500">月均阅读量</p>
              </div>
              <div className="text-center">
                <div className="text-3xl md:text-4xl font-bold text-primary-500 mb-1">
                  50<span className="text-accent-500">+</span>
                </div>
                <p className="text-sm text-foreground-500">爆料分类频道</p>
              </div>
              <div className="text-center">
                <div className="text-3xl md:text-4xl font-bold text-primary-500 mb-1">
                  7×24<span className="text-accent-500">h</span>
                </div>
                <p className="text-sm text-foreground-500">不打烊更新</p>
              </div>
            </div>
          </div>
        </section>

        {/* Featured + Hot Topics */}
        <section className="px-4 md:px-6 lg:px-8 py-10 md:py-16 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-8">
              {/* Articles */}
              <div className="lg:col-span-2">
                <div className="flex items-center justify-between mb-6 md:mb-8">
                  <div>
                    <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-1">
                      最新爆料
                    </h2>
                    <p className="text-sm text-foreground-500">
                      全网热点实时追踪，第一手吃瓜资讯
                    </p>
                  </div>
                  <Link
                    to="/category/entertainment"
                    className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors"
                  >
                    更多资讯
                    <i className="ri-arrow-right-line" />
                  </Link>
                </div>

                <div className="space-y-4 md:space-y-5">
                  {latestArticles.map((article) => (
                    <article
                      key={article.id}
                      className="flex flex-col sm:flex-row gap-4 p-4 rounded-xl bg-background-100 hover:bg-background-200/70 transition-colors group"
                      itemScope
                      itemType="https://schema.org/Article"
                    >
                      <Link
                        to={`/article/${article.id}`}
                        className="block w-full sm:w-40 md:w-48 flex-shrink-0 rounded-lg overflow-hidden aspect-[16/10] cursor-pointer"
                      >
                        <img
                          src={article.coverImage}
                          alt={article.title}
                          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                          width={400}
                          height={250}
                          itemProp="image"
                        />
                      </Link>
                      <div className="flex-1 min-w-0">
                        <div className="flex items-center gap-2 mb-2 flex-wrap">
                          <Link
                            to={`/category/${article.category}`}
                            className="text-xs font-medium px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 whitespace-nowrap"
                          >
                            {article.categoryName}
                          </Link>
                          <span className="text-xs text-foreground-400">
                            {article.publishDate}
                          </span>
                        </div>
                        <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors">
                          <Link
                            to={`/article/${article.id}`}
                            itemProp="headline"
                            className="cursor-pointer"
                          >
                            {article.title}
                          </Link>
                        </h3>
                        <p className="text-sm text-foreground-500 line-clamp-2 mb-2 hidden sm:block">
                          {article.summary}
                        </p>
                        <div className="flex items-center gap-3 text-xs text-foreground-400">
                          <span className="flex items-center gap-1">
                            <i className="ri-eye-line" />
                            {formatNumber(article.viewCount)}
                          </span>
                          <span className="flex items-center gap-1">
                            <i className="ri-time-line" />
                            {article.readTime}分钟
                          </span>
                        </div>
                      </div>
                    </article>
                  ))}
                </div>
              </div>

              {/* Sidebar: Hot Topics + Featured */}
              <aside className="space-y-6">
                {/* Hot Topics */}
                <div className="p-4 md:p-5 rounded-xl bg-background-100">
                  <h3 className="text-lg font-bold text-foreground-950 mb-4 flex items-center gap-2">
                    <i className="ri-fire-fill text-primary-500" />
                    实时热榜
                  </h3>
                  <div className="space-y-3">
                    {hotTopics.map((topic, index) => (
                      <div
                        key={topic.id}
                        className="flex items-start gap-3 group cursor-pointer"
                      >
                        <span
                          className={`flex-shrink-0 w-5 h-5 rounded text-xs font-bold flex items-center justify-center ${
                            index < 3
                              ? "bg-primary-500 text-background-50"
                              : "bg-background-200 text-foreground-500"
                          }`}
                        >
                          {index + 1}
                        </span>
                        <div className="flex-1 min-w-0">
                          <p className="text-sm text-foreground-700 group-hover:text-primary-500 transition-colors line-clamp-1">
                            {topic.title}
                          </p>
                          <div className="flex items-center gap-2 mt-0.5">
                            <div className="flex-1 h-1 bg-background-200 rounded-full overflow-hidden">
                              <div
                                className="h-full bg-primary-400 rounded-full"
                                style={{ width: `${topic.heat}%` }}
                              />
                            </div>
                            <span className="text-xs text-foreground-400">
                              {topic.heat}°
                            </span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Featured Cards */}
                <div className="p-4 md:p-5 rounded-xl bg-background-100">
                  <h3 className="text-lg font-bold text-foreground-950 mb-4 flex items-center gap-2">
                    <i className="ri-star-fill text-accent-500" />
                    精选推荐
                  </h3>
                  <div className="space-y-3">
                    {featuredArticles.slice(0, 4).map((article) => (
                      <Link
                        key={article.id}
                        to={`/article/${article.id}`}
                        className="flex gap-3 group cursor-pointer"
                      >
                        <div className="w-16 h-16 flex-shrink-0 rounded-lg overflow-hidden">
                          <img
                            src={article.coverImage}
                            alt={article.title}
                            className="w-full h-full object-cover object-top"
                            width={64}
                            height={64}
                          />
                        </div>
                        <div className="flex-1 min-w-0">
                          <p className="text-sm text-foreground-700 group-hover:text-primary-500 transition-colors line-clamp-2">
                            {article.title}
                          </p>
                          <span className="text-xs text-foreground-400 mt-1 block">
                            {article.publishDate}
                          </span>
                        </div>
                      </Link>
                    ))}
                  </div>
                </div>

                {/* Tags Cloud */}
                <div className="p-4 md:p-5 rounded-xl bg-background-100">
                  <h3 className="text-lg font-bold text-foreground-950 mb-4 flex items-center gap-2">
                    <i className="ri-price-tag-3-fill text-secondary-500" />
                    热门标签
                  </h3>
                  <div className="flex flex-wrap gap-2">
                    {Array.from(
                      new Set(articles.flatMap((a) => a.tags))
                    ).slice(0, 14).map((tag) => (
                      <span
                        key={tag}
                        className="text-xs px-3 py-1.5 rounded-full bg-background-200 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              </aside>
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="px-4 md:px-6 lg:px-8 py-10 md:py-16 bg-background-100">
          <div className="max-w-3xl mx-auto">
            <div className="text-center mb-8 md:mb-10">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
                常见问题
              </h2>
              <p className="text-sm md:text-base text-foreground-500">
                关于黑料在线的疑问，这里都有答案
              </p>
            </div>
            <div className="space-y-3">
              {homeFAQ.map((faq, index) => (
                <div
                  key={index}
                  className="rounded-xl bg-background-50 border border-background-200/70 overflow-hidden"
                >
                  <button
                    className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer"
                    onClick={() =>
                      setOpenFaq(openFaq === index ? null : index)
                    }
                    aria-expanded={openFaq === index}
                  >
                    <span className="text-sm md:text-base font-semibold text-foreground-900 pr-4">
                      {faq.question}
                    </span>
                    <i
                      className={`ri-arrow-down-s-line text-lg text-foreground-400 flex-shrink-0 transition-transform ${
                        openFaq === index ? "rotate-180" : ""
                      }`}
                    />
                  </button>
                  {openFaq === index && (
                    <div className="px-4 md:px-5 pb-4 md:pb-5">
                      <p className="text-sm text-foreground-500 leading-relaxed">
                        {faq.answer}
                      </p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="relative overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20dark%20elegant%20background%20with%20subtle%20red%20and%20gold%20light%20rays%2C%20dramatic%20gradient%20atmosphere%2C%20entertainment%20show%20stage%20vibe%2C%20minimalist%20artistic%20composition%2C%20cinematic%20lighting%20with%20deep%20shadows&width=1600&height=600&seq=cta-bg&orientation=landscape"
              alt="订阅黑料在线"
              className="w-full h-full object-cover object-top"
              width={1600}
              height={600}
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/70" />
          </div>
          <div className="relative z-10 px-4 md:px-6 lg:px-8 py-12 md:py-20 text-center">
            <h2 className="text-2xl md:text-4xl font-bold text-white mb-3 md:mb-4">
              不错过任何一则爆料
            </h2>
            <p className="text-sm md:text-base text-white/70 mb-6 md:mb-8 max-w-xl mx-auto leading-relaxed">
              订阅黑料在线，独家爆料第一时间推送至你的手中
              <br className="hidden md:block" />
              每日精选，吃瓜永不停歇
            </p>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-6 md:px-8 py-3 md:py-3.5 bg-accent-500 text-background-950 rounded-full text-sm md:text-base font-semibold hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              了解更多
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
